import { render, staticRenderFns } from "./EmployessProfile.vue?vue&type=template&id=68f2a9ac&"
import script from "./EmployessProfile.vue?vue&type=script&lang=js&"
export * from "./EmployessProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports